import { StringDictionary } from '../defines/common';

function getParam(key: string, url?: string) {
  let search = '';

  if (!url) {
    search = window.location.search
      .replace(/[%]/g, (m) => `%${m.charCodeAt(0).toString(16)}`);
  } else {
    const linkEL = document.createElement('a');
    linkEL.href = url;
    search = linkEL.search;
  }

  const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`);
  const matched = search.substr(1).match(reg);
  if (matched != null) {
    return decodeURIComponent(matched[2]);
  }
  return '';
}

/**
 * 替换url中的参数 匹配{id}与:id
 *
 * @param    {String}  str        字符串链接
 * @param    {Object}  param      参数对象
 * @return   {String}  替换参数后的链接
 */
function replaceParams(str: string, param: StringDictionary) {
  const reg0 = /\{(.*?)\}/gi;
  const reg1 = /:([^-/|.]*)/gi;

  return str
    .replace(reg0, ($0, $1) => param[$1] || $0)
    .replace(reg1, ($0, $1) => param[$1] || $0);
}

function setParam(url: string, name: string, value: string) {
  let newUrl = url;
  const regex = new RegExp(`(\\?|\\&)(${name}=).*?(&|$)`);
  const linkEL = document.createElement('a');
  linkEL.href = url;
  let { search, pathname, origin } = linkEL;
  const { hash } = linkEL;
  if (!origin) {
    origin = `${linkEL.protocol}//${linkEL.hostname}${linkEL.port ? `:${linkEL.port}` : ''}`; // 兼容 origin
  }
  pathname = (pathname.indexOf('/') === 0 ? '' : '/') + pathname; // 兼容 pathname 在部分 IE 下缺少前缀

  if (search && search.search(regex) >= 0) {
    search = search.replace(regex, `$1$2${value}$3`);
  } else {
    search = `${(search ? `${search}&` : '?')}${name}=${value}`;
  }
  newUrl = `${origin}${pathname}${search}${hash}`;
  return newUrl;
}

/**
 * 获取url的查询参数的值
 *
 * @param    {String}  name        字符串链接
 * @param    {Object}  url      参数对象
 * @return   {String}  替换参数后的链接
 */
function getParameterByName(name: string, url?: string) {
  const targetUrl = url || window.location.href;
  const newName = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${newName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(targetUrl);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * 删除URL中指定参数，不支持url中存在hash值的情况
 * @param key 待删除参数名
 * @param url 待处理url
 * @returns 处理完url
 */
function deleteParam(key: string, url?: string) {
  const href = url || window.location.href;
  const urlParts = href.split('?');
  if (urlParts.length >= 2) {
    // 参数名前缀
    const prefix = `${encodeURIComponent(key)}=`;
    const pars = urlParts[1].split(/[&;]/g);

    // 循环查找匹配参数
    for (let i = 0; i < pars.length; i += 1) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        // 存在则删除
        pars.splice(i, 1);
      }
    }

    return urlParts[0] + (pars.length > 0 ? `?${pars.join('&')}` : '');
  }
  return href;
}

export default {
  getParam,
  setParam,
  replaceParams,
  getParameterByName,
  deleteParam,
};
